import React from 'react';
import PropTypes from 'prop-types';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemText from '@material-ui/core/ListItemText';
import { getSitePlanningUrl } from '../../../../helpers/cleanyApp';

// La déclaration d'une préaffectation se fait dans CleanyApp (plan 070b) :
// le lien ouvre, dans un nouvel onglet, le planning du site de ce compte.
const PreaffectationButton = ({ className, record }) => {
  return (
    <MenuItem
      className={className}
      component="a"
      href={getSitePlanningUrl(record && record.id)}
      target="_blank"
      rel="noopener noreferrer"
    >
      <ListItemText
        primary="📣 Déclarer une préaffectation ↗"
        secondary="Dans CleanyApp, planning du site"
      />
    </MenuItem>
  );
};

PreaffectationButton.propTypes = {
  className: PropTypes.string,
  record: PropTypes.object,
};

PreaffectationButton.defaultProps = {
  className: undefined,
  record: undefined,
};

export default PreaffectationButton;
